import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import CardModal from './CardModal.jsx';
import {actions} from './actions.mjs';
import CardsList from './CardsList.jsx';
import defaultMessages from './messages.mjs';
import {IntlProvider} from 'react-intl';
import {cssBEM} from './index.jsx';
import PropTypes from 'prop-types';
import {CardShape} from './shapes.jsx';

const CardBuilder = props => {
  const {
    activeCardId,
    cards,
    className,
    locale,
    messages,
    onChange,
    showAllMode,
    disabled,
    ...rest
  } = props;

  useEffect(() => {
    if(disabled) {
      setShowCardOptions(false);
    }
  }, [disabled]);

  const activeCard = activeCardId ? cards.find(({id}) => id === activeCardId) : false;
  const [showCardOptions, setShowCardOptions] = useState(false);
  const showModal = !disabled && (showCardOptions || activeCard);
  const classes = classnames(cssBEM, className, {
    [`${cssBEM}--modal-active`]: showModal,
    [`${cssBEM}--showAllMode`]: showAllMode
  });
  const i18nMessages = {
    ...defaultMessages,
    ...messages
  };

  const addCard = card => {
    if(showAllMode && card){
      onChange({
        card,
        action: actions.CARD_ADDED
      });
    }else{
      setShowCardOptions(true);
    }
  };

  const editCard = card => {
    onChange({
      card,
      action: actions.EDIT
    });
  };

  const removeCard = card => {
    onChange({
      card,
      action: actions.CARD_REMOVED
    });
  };

  const saveCard = () => {
    onChange({
      card: activeCard,
      action: actions.CARD_SAVED
    });
    setShowCardOptions(false);
  };

  const onCloseModal = () => {
    onChange({ action: actions.MODAL_CLOSED });
    setShowCardOptions(false);
  };

  return (
    <IntlProvider locale={ locale || 'en' } messages={i18nMessages}>
      <div className={classes}>
        <CardsList
          {...rest}
          onAddClicked={addCard}
          onEditClicked={editCard}
          onRemoveClicked={removeCard}
          showAllMode={showAllMode}
          cards={cards}
          disabled={disabled}
        />
        { showModal ?
          <CardModal
            {...rest}
            activeCard={activeCard}
            onClose={onCloseModal}
            onSave={saveCard}
          /> : null
        }
      </div>
    </IntlProvider>
  );
};

CardBuilder.propTypes = {
  activeCardId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]),
  cards: PropTypes.arrayOf(CardShape).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  locale: PropTypes.string,
  messages: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  renderCardBodyFn: PropTypes.func,
  renderModalHeaderFn: PropTypes.func,
  renderModalBodyFn: PropTypes.func,
  renderOptions: PropTypes.func,
  renderQuestion: PropTypes.func.isRequired,
  showAllMode: PropTypes.bool,
  values: PropTypes.array,
  listContainerProps: PropTypes.object
};

export default CardBuilder;
